import { GridInput } from '@it2go/data-grid';
import { Injectable } from '@angular/core';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    EmploymentTypeEducationGridObject,
    EmploymentTypeEducationObject,
} from '@libs/types/src/services/object-type/employment-type-education.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { filterFrag } from './types/filter.types';
import { employmentTypeEducationFrag } from './types/education.types';

@Injectable({ providedIn: 'root' })
export class EmploymentTypeEducationGqlService extends GqlServiceV2 {
    public getEmploymentTypeEducation(
        input: IdInput,
        fragment: string = employmentTypeEducationFrag,
    ) {
        return this.query<EmploymentTypeEducationObject>(
            `
                query($input: IdInput!) {
                    employmentTypeEducation {
                        get(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getEmploymentTypeEducations(
        input: GridInput | null = null,
        fragment: string = employmentTypeEducationFrag,
    ) {
        return this.query<EmploymentTypeEducationGridObject>(
            `
                query($input: GridInput) {
                    employmentTypeEducation {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
